{
    "ConsidermovedtounresolvedasoverflowedLabel": "Considera le chiamate spostate su dispositivi non risolti come overflow:",
    "StatisticCalculations_SectionHeader": "Calcoli statistici",
    "StatisticCalculations_SectionPara": "È possibile scegliere se le chiamate sono considerate in overflow o abbandonate quando l'applicazione termina deliberatamente la loro modellazione per le chiamate spostate in posizioni di dispositivi non monitorati o sconosciuti.",
    "NAME": "StatisticCalculations"
}